module.exports = __webpack_public_path__ + "img/pic-1.d3c64428.png";